//@flow
import React from 'react';

import type QuoteItemModel from '../../Stores/Quote/quoteItemModel';
import type OrderItemModel from '../../Stores/Order/orderItemModel';
import type ProductModel from '../../Stores/Products/productModel';

type Props = {
  giftItem:QuoteItemModel|OrderItemModel,
  removeProduct?:()=>void,
  product:?ProductModel,
  type:"order"|"quote",
};

function renderLine(name:string, value:string) {
  if (!value) return null;
  if (value.length > 100) value = value.slice(0,98) + '...';
  return (
    <div className="line">
      <span className="bold">{name}: </span>
      <span>{value}</span>
    </div>
  );
}

function getImage(props:Props) {
  const img = props.product && props.product.getSmallSquareImageUrl(96,96);
  if (!img) return null;
  return <img src={img} alt="gift-card" />;
}

function getRemoveButton(props:Props) {
  if (!props.removeProduct) return null;
  return (
    <span onClick={props.removeProduct} className="remove">Remove </span>
  );
}

export default function GiftCardItem(props:Props) {
  const params = props.giftItem.getParams();
  if (!props.giftItem.isGiftVoucher() || !props.giftItem.getParams()) return null;
  const amount  = params.amount;
  const from = params.customer_name;
  const to = params.recipient_name;
  const email = params.recipient_email;
  const message = params.message;
  const day_to_send = params.day_to_send;

  return (
    <div className={`${props.type}-item-block gift-card`}>
      <div className="gift-card-image">
        {getImage(props)}
      </div>
      <div className="content">
        <div className="title bold">
          ${amount} Gift card
        </div>
        {renderLine('From', from)}
        {renderLine('To', to)}
        {renderLine('Email', email)}
        {renderLine('Message', message)}
        {renderLine('Send On', day_to_send)}
        {getRemoveButton(props)}
      </div>
    </div>
  );
}
